import types from '../constants';

const showErrorAlert = (alertMessage) => {
  return {
    type: types.SHOW_ALERT_ERROR,
    payload: {
      alertMessage
    },
  }
}

const showSuccessAlert = (alertMessage) => {
  return {
    type: types.SHOW_ALERT_SUCCESS,
    payload: {
      alertMessage
    },
  }
}

const closeAlert = () => {
  return {
    type: types.CLOSE_ALERT
  }
}

export {
  showErrorAlert,
  showSuccessAlert,
  closeAlert
}